<template>
  <transition name="gl-fade">
    <div
      v-if="state.visible"
      class="global-loader"
      role="status"
      aria-live="polite"
    >
      <div class="global-loader__box">
        <div class="global-loader__spinner"></div>
        <p v-if="state.message" class="global-loader__text">
          {{ state.message }}
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
import { loaderState } from "@/services/loader";

export default {
  name: "GlobalLoader",
  data() {
    return { state: loaderState };
  },
};
</script>

<style>
/* Same spinner as the existing page preloaders: grey ring, theme-orange arc */
.global-loader {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.75);
}

.global-loader__box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(2, 34, 40, 0.15);
}

.global-loader__spinner {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top-color: #f48226;
  animation: global-loader-spin 1s infinite linear;
}

.global-loader__text {
  margin: 14px 0 0;
  color: #022228;
  font-weight: 600;
  font-size: 14px;
}

@keyframes global-loader-spin {
  to {
    transform: rotate(360deg);
  }
}

.gl-fade-enter-active,
.gl-fade-leave-active {
  transition: opacity 0.15s ease;
}

.gl-fade-enter-from,
.gl-fade-leave-to {
  opacity: 0;
}
</style>